/**
 * A frame's participant id as the store keys it: recall speaker ids arrive as
 * JSON numbers, standalone ids as strings (`salesperson_2`, `customer_1`).
 * Undefined when the frame names nobody.
 */
export const participantIdOf = (value: unknown): string | undefined =>
  (typeof value === 'string' && value !== '') || typeof value === 'number' ? String(value) : undefined;
